import api from '@/services/api/api';

export const useTimeline = (
  params = {
    filters: {},
  },
) => {
  const timeline = useQuery(
    ['timeline', params.filters],
    async () => {
      const { data } = await api.timeline.getTimeline(toValue(params.filters));
      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await timeline.suspense();
  });

  return {
    timeline,
  };
};
